<template>
<div class="sidebar mainsidebar">
    <span class="pinsidebar" @click.prevent="toggleSidebar(true)" v-if="!showSidebar"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
    <span class="pinsidebar" @click.prevent="toggleSidebar(false)" v-if="showSidebar"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
    <div slot="header" class="sidebar__header">
      <b-link class="navbar-brand" :to="{name: 'home'}">
          <svg-logo/>
      </b-link>
    </div>
    <nav class="sidebar-nav">
        <ul class="nav" v-if="!objectStoreOnly">
            <li class="nav-item nodropdown">
                <router-link :to="{name: 'instances'}" :class="{'router-link-exact-active': subIsActive(['instance','kubernetes','cluster','container', 'gpu'])}" class="nav-link"><i class="fa fa-rocket"></i> Compute</router-link>
            </li>
            <li class="nav-item nav-dropdown"  :class="{open: openMenuItems.indexOf('emk') > -1}">
                <div class="nav-link nav-dropdown-toggle" @click="toggleDropdown('emk')"><i class="fa fa-cubes"></i> EMK</div>
                <ul class="nav-dropdown-items">
                    <li class="nav-item">
                        <router-link :to="{name: 'managed-kubernetes'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('emk')}">EMK clusters</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'emk-secrets'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('gardenerPagesSecrets')}">Secrets</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'emk-service-accounts'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('service')}">Service accounts</router-link>
                    </li>
                </ul>
            </li>

            <li class="nav-item nav-dropdown" :class="{open: openMenuItems.indexOf('storage') > -1}">
                <div class="nav-link nav-dropdown-toggle" @click="toggleDropdown('storage')"><i class="fa fa-database"></i> Storage</div>
                <ul class="nav-dropdown-items">
                    <li class="nav-item">
                        <router-link :to="{name: 'object-store'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('object-store')}">Object Store</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'volume-store'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('volume-store')}">Volume Store</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'volume-backup'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('volume-backup')}">Volume backups</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'images'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('image')}">Images</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'snapshots'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('snapshot')}">Snapshots</router-link>
                    </li>
                </ul>
            </li>

            <li class="nav-item nav-dropdown" :class="{open: openMenuItems.indexOf('network') > -1}">
                <div class="nav-link nav-dropdown-toggle" @click="toggleDropdown('network')"><i class="fa fa-sitemap"></i> Network</div>
                <ul class="nav-dropdown-items">
                    <li class="nav-item">
                        <router-link :to="{name: 'networkTopo'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('network-topo')}">Network Topology</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'networks'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('networks')}">Networks</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'ports'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('port')}">Ports</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'routers'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('router')}">Routers</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'ip-addresses'}" class="nav-link">IP Addresses</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'security-groups'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('security-group')}">Security Groups</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'load-balancers'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('load-balancer')}">Load Balancers</router-link>
                    </li>
                </ul>
            </li>

            <li class="nav-item nav-dropdown" :class="{open: openMenuItems.indexOf('services') > -1}">
                <div class="nav-link nav-dropdown-toggle" @click="toggleDropdown('services')"><i class="fa fa-cogs"></i> Services</div>
                <ul class="nav-dropdown-items">
                    <li class="nav-item">
                        <router-link :to="{name: 'dns'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('dns')}">DNS</router-link>
                    </li>
                </ul>
            </li>

            <li class="nav-item nav-dropdown" :class="{open: openMenuItems.indexOf('access') > -1}">
                <div class="nav-link nav-dropdown-toggle" @click="toggleDropdown('access')"><i class="fa fa-key"></i> Access</div>
                <ul class="nav-dropdown-items">
                    <li class="nav-item">
                        <router-link :to="{name: 'key-pairs'}" class="nav-link">Key Pairs</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'app-credentials'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('credential') || subIsActive('access-rules')}">Credentials</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'api-endpoints'}" class="nav-link" :class="{'router-link-exact-active': subIsActive('endpoint')}">API Endpoints</router-link>
                    </li>
                </ul>
            </li>
        </ul>
        <ul class="nav" v-else>
            <li class="nav-item nodropdown">
                <router-link :to="{name: 'object-store'}" :class="{'router-link-exact-active': subIsActive(['instance','kubernetes','cluster','container', 'gpu'])}" class="nav-link"><i class="fa fa-database"></i> Object Store</router-link>
            </li>
            <li class="nav-item nodropdown">
                <router-link :to="{name: 'credentials'}" :class="{'router-link-exact-active': subIsActive('credential') || subIsActive('access-rules')}" class="nav-link"><i class="fa fa fa-key"></i> Credentials</router-link>
            </li>
        </ul>
        <slot></slot>
    </nav>
</div>
</template>


<script>
import { DASHBOARD_URL } from '@/assets/js/config';
import cSidebar from 'core-ui-vue/src/components/Sidebar/Sidebar';
import fSidebarNavDropdown from '@/components/f-sidebar-nav-dropdown';
const svgLogo = () => import('@/components/svg/svg-logo');
import fSidebarAccount from '@/components/menu/f-sidebar-account';
import fSidebarAccountService from '@/components/menu/f-sidebar-account-service';

export default {
    extends: cSidebar,

    data() {
        return {
            openMenuItems: localStorage.getItem('menu_items') ? JSON.parse(localStorage.getItem('menu_items')) : [],
        }
    },

    methods: {
        toggleSidebar(value) {
            this.$store.commit('misc/SHOW_SIDEBAR', value);
            document.cookie = "sidebar=" + value;
        },

        toggleDropdown(menuItem) {
            let data = localStorage.getItem('menu_items') ? JSON.parse(localStorage.getItem('menu_items')) : [];
            let index = data.indexOf(menuItem);
            if (index >= 0) {
                data.splice(index, 1);
            } else {
                data.push(menuItem);
            }
            if (data.length === 0) {
                localStorage.removeItem('menu_items');
            } else {
                localStorage.setItem('menu_items', JSON.stringify(data));
            }

            this.openMenuItems = data
        },

        openCurrentDropdown() {
            setInterval(() => {
                let parent = undefined;
                if (document.querySelector('.router-link-exact-active')) {
                    parent = document.querySelector('.router-link-exact-active').closest('.nav-dropdown');
                    if (parent !== null) {
                        parent.classList.add('open', 'child-active');
                    }
                }
            }, 0);
        },

        subIsActive(input) {
            const paths = Array.isArray(input) ? input : [input];
            return paths.some(path => {
                if (this.$route.meta.sidebar) {
                    return this.$route.meta.sidebar.indexOf(path) > -1;
                }
            });
        },

        handleLoader() {
            this.$store.commit('misc/PAGE_LOADING', true);
        }
    },

    computed: {
    },

    mounted() {
        this.openCurrentDropdown();
    },

    components: {
        fSidebarNavDropdown,
        svgLogo,
        fSidebarAccount,
        fSidebarAccountService,
    }
}
</script>
<style scoped="scoped">
.sidebar .nav-dropdown-items {
}
.sidebar .nav,
.sidebar .sidebar-nav {
    width: 240px;
}
.app-body .sidebar {
      flex: 0 0 240px;
}
.mainsidebar:hover {
    max-width: 240px !important;
    width: 240px;
}
.nodropdown {
  height: 50px;
}
.sidebar .nav-item:not(.nav-dropdown):hover {
    background: rgba(0,0,0,.4)
}
.sidebar .nav-dropdown-items .nav-link {
    display: flex !important;
    line-height: 30px;
    width: 180px;
    padding: 10px 10px 10px 56px;
    width: 240px;
}
.mainsidebar .pinsidebar {
    margin: 15px 10px 0 0;
}


</style>
<style>
.navbar-brand {
    position: relative;
    height: 75px;
    width: 50px;
    overflow: hidden;
    margin-left: -9px;
}

.sidebaropen .navbar-brand,
.mainsidebar:hover .navbar-brand {
    position: relative;
    height: 75px;
    width: 170px;
    overflow: hidden;
    margin-left: -9px;
}
.logo {
    margin-left: -78px;
    transition: .2s;
}

.sidebaropen .logo,
.mainsidebar:hover .navbar-brand .logo  {
    margin-left: 10px;
    transition: .2s;
}
</style>